/**
 * What a support message carries without the salon typing it: the page
 * they came from, their device and which Beu they are on (approved
 * mockups: "Sends this page and your device"). Bailey and the team read
 * these first, so nobody has to ask "what are you using?".
 *
 * The page is remembered by the chat icon in every page header
 * (MessagesHeaderButton calls rememberPage), so opening Support from the
 * diary sends "Diary" even though the chat lives on /messages.
 */
import { createContext } from 'react';

const KEY = 'bm:lastPage';

const PAGES = [
    ['diary', 'Diary'], ['pos', 'Point of Sale'], ['checkout', 'Point of Sale'], ['clients', 'Clients'],
    ['catalogue', 'Catalogue'], ['staff', 'Team'], ['team', 'Team'], ['marketing', 'Marketing'],
    ['finance', 'Finance'], ['settings', 'Settings'], ['assistant', 'Bailey'], ['social', 'Social'],
];

export function pageLabel(pathname) {
    const first = String(pathname || '').split('/').filter(Boolean)[0] || '';
    const hit = PAGES.find(([key]) => first.toLowerCase().indexOf(key) === 0);
    return hit ? hit[1] : null;
}

export function rememberPage(pathname) {
    const label = pageLabel(pathname);
    if (!label) return;
    try { sessionStorage.setItem(KEY, label); } catch (e) { /* private mode: we just send Messages */ }
}

function deviceName() {
    const ua = navigator.userAgent || '';
    if (/iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'iPad';
    if (/iPhone/.test(ua)) return 'iPhone';
    if (/Android/.test(ua)) return /Mobile/.test(ua) ? 'Android phone' : 'Android tablet';
    if (/Macintosh/.test(ua)) return 'Mac';
    if (/Windows/.test(ua)) return 'Windows';
    return 'Browser';
}

function appName() {
    const native = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    return native ? 'Beu app' : 'Beu web';
}

/** ['Point of Sale', 'iPad', 'Beu web'] */
export function supportContext() {
    let page = null;
    try { page = sessionStorage.getItem(KEY); } catch (e) { page = null; }
    return [page || 'Messages', deviceName(), appName()];
}

/**
 * What support messages and cards can ask the open chat to do:
 * { openTicket(ref), talkToTeam(), feedback(message, helped), rate(message, rating) }
 */
export const SupportActions = createContext(null);
